/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Box, Flex } from '@chakra-ui/react'

const Logo = ({
  className = '',
  isDefaultLogoUrl,
  logoUrl
}) => {
  const imgClass = isDefaultLogoUrl
    ? 'w-full'
    : 'h-full'
  return (
    <>
      { logoUrl &&
        <Flex as={NavLink}
          className={className}
          flexGrow={0}
          flexShrink={0}
          alignItems="center"
          pr={{ xl: 6 }}
          to="/"
        >
          <Box
            width={{
              base: '170px',
              md: '220px'
            }}
            height={isDefaultLogoUrl ? undefined : '50px'}
            textAlign="center"
          >
            <img src={logoUrl} className={`${imgClass} !inline-block`} />
          </Box>
        </Flex>
      }
    </>
  )
}

export default Logo
